import React from 'react';
import { commonFunction } from './actions';
import makeSelectInit from './selectors';
import reducer from './reducer';
import saga from './saga';
import { createStructuredSelector } from 'reselect';
import injectReducer from '../../utils/injectReducer';
import injectSaga from '../../utils/injectSaga';
import { connect } from 'react-redux';
import { compose } from 'redux';

export class Init extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.commonFunction('init call');
  }

  render() {
    return <div />;
  }
}

export function mapDispatchToProps(dispatch) {
  return {
    commonFunction: datapack => {
      dispatch(commonFunction(datapack));
    },
  };
}

const mapStateToProps = createStructuredSelector({
  init: makeSelectInit(),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

const withReducer = injectReducer({ key: 'init', reducer });
const withSaga = injectSaga({ key: 'init', saga });

export default compose(
  withReducer,
  withSaga,
  withConnect,
)(Init);
